import { COMPANY_LINK_REQUEST_SIDE } from '@shared/schema/companyParent.js';

/* Which permission a link change needs depends on the role this organization plays in it: acting as
   the parent needs child_company:manage (canManageChildren), acting as the child needs the
   Owner-only company:parent:manage (canManageParent). The server checks the same split. */
const canManageOrganizationLinkSide = ({ side, capabilities } = {}) => {
  if (side === COMPANY_LINK_REQUEST_SIDE.PARENT) {
    return capabilities?.canManageChildren === true;
  }

  return side === COMPANY_LINK_REQUEST_SIDE.CHILD && capabilities?.canManageParent === true;
};

export default canManageOrganizationLinkSide;
